import { clientPayload as etClientPayload } from "@flights/et-universal";
import { checkAppVersion, getMarketingTrackingVariable, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { X_BOOKING_FLIGHTS_DEV_SERVICE_OVERRIDE, devOverrideUtils } from "@flights/dev-overrides-universal";
import { X_BOOKING_FLIGHTS_CLIENT_HINTS, X_FLIGHTS_AWS_WAF_INTEGRATION } from "@flights/constants";
import { appendFeatureAndExperimentParams, appendLanguageOptionParam, appendSelectedCurrencyParam } from "./utils.js";
import { clientFetchEventsEmitter } from "./client-fetch-events.js";
export class ClientFetchError extends Error {
    constructor(message) {
        super(message);
        this.name = "ClientFetchError";
    }
}
export class ClientFetchNotAuthorizedError extends ClientFetchError {
    constructor(message) {
        super(message);
        this.name = "ClientFetchNotAuthorizedError";
    }
}
export function clientFetch(...args) {
    const { debugAllExtraProducts, marketingTrackingVariables: trackingVariables, emkToken, isInternal, soylentEmail, tracingHeaders } = window.__GLOBAL_CONTEXT__;
    const [url, options = {}] = args;
    const headers = new Headers({ ...options.headers, ...tracingHeaders });
    headers.set("X-Requested-From", "clientFetch");
    const aid = getMarketingTrackingVariable("aid") || trackingVariables?.aid;
    const label = getMarketingTrackingVariable("label") || trackingVariables?.label;
    const distributionId = getMarketingTrackingVariable("distribution_id") || trackingVariables?.distributionId;
    const etgTestUrl = sessionStorage && sessionStorage.getItem("debugEtgUrl");
    const debugAllTravelerDataRequirements = sessionStorage && sessionStorage.getItem("debugAllTravelerDataRequirements");
    if (aid) {
        headers.set("X-Booking-Affiliate-Id", aid);
    }
    if (label) {
        headers.set("X-Booking-Label", label);
    }
    if (emkToken) {
        headers.set("X-Booking-EMK-Token", emkToken);
    }
    if (debugAllExtraProducts) {
        headers.set("X-Flights-Debug-All-Products", "1");
    }
    if (soylentEmail) {
        headers.set("X-Soylent-Email", soylentEmail);
    }
    if (etgTestUrl) {
        headers.set("X-Flights-Debug-Etg-Test-Url", etgTestUrl);
    }
    if (debugAllTravelerDataRequirements) {
        headers.set("X-Flights-Debug-All-Traveler-Data-Requirements", "1");
    }
    if (distributionId) {
        headers.set("X-Booking-Distribution-Id", distributionId);
    }
    const hints = ["price_change_v2"];
    headers.set(X_BOOKING_FLIGHTS_CLIENT_HINTS, hints.join(","));
    if (isInternal) {
        const devOverrides = devOverrideUtils.getAll();
        if (typeof devOverrides == "object" && Object.keys(devOverrides).length) {
            headers.set(X_BOOKING_FLIGHTS_DEV_SERVICE_OVERRIDE, JSON.stringify(devOverrides));
        }
    }
    if (!options.credentials) {
        options.credentials = "same-origin";
    }
    let apiPrefix = "";
    if (String(url).startsWith("/")) {
        apiPrefix = window.__GLOBAL_CONTEXT__?.apiPrefix;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const a11yMobileView = urlParams.get("a11y_mobile_view");
    if (a11yMobileView === "1") {
        headers.set("X-Booking-A11y-Mobile-View", "1");
    }
    let fetchUrl = String(url);
    if (a11yMobileView === "1") {
        const urlObj = new URL(fetchUrl, window.location.origin);
        urlObj.searchParams.set("a11y_mobile_view", "1");
        fetchUrl = urlObj.toString();
    }
    if (isInternal)
        fetchUrl = appendFeatureAndExperimentParams(fetchUrl);
    fetchUrl = appendSelectedCurrencyParam(fetchUrl);
    fetchUrl = apiPrefix + appendLanguageOptionParam(fetchUrl);
    let fetchApi = window.fetch;
    if (isFeatureRunningClientSide("FLIGHTS_WEB_ENABLE_AWS_WAF_FETCH_WRAPPER")) {
        if (!!window?.AwsWafIntegration?.fetch) {
            fetchApi = window.AwsWafIntegration.fetch;
        }
        if (isFeatureRunningClientSide("FLIGHTS_WEB_ENABLE_AWS_WAF_INTEGRATION_HEADER_PROPAGATE")) {
            headers.set(X_FLIGHTS_AWS_WAF_INTEGRATION, !!window?.AwsWafIntegration?.fetch ? "1" : "0");
        }
    }
    return fetchApi(fetchUrl, { ...options, headers })
        .then((res) => {
        checkAppVersion.checkForAppVersionMismatch(res.headers.get("X-Booking-App-Version"));
        if (isFeatureRunningClientSide("FLIGHTS_FETA_ENABLE_API_VERSION_RESPONSE_HEADER")) {
            if (isInternal) {
                clientFetchEventsEmitter.emit("responseReceived", {
                    res
                });
            }
        }
        if (res.ok) {
            if (res.headers.get("Content-Type") === "application/pdf") {
                return res.blob();
            }
            return res.json();
        }
        else {
            if (res.status === 403) {
                throw new ClientFetchNotAuthorizedError("Fetch: Not Authorized");
            }
            else {
                throw new ClientFetchError("Fetch: Non-OK response");
            }
        }
    })
        .then((data) => {
        etClientPayload.checkForNewClientsidePayload(data?._meta?._clientsidePayload);
        if (data.error) {
            throw data.error;
        }
        return data;
    });
}
